import http from '@utils/http';
import { Toast } from 'vant';

// 上传文件
export function uploadFile(param) {
  const config = {
    contentType: false,
    processData: false,
  };
  return http
    .post(
      '/phoenix/phoenix/arctic/v1/upload/noVerificationRequired',
      param,
      {},
      config
    )
    .then(res => {
      if (res.status === 200) {
        return res.data;
      } else {
        Toast({
          message: res.message || '上传失败',
          duration: 3000,
          position: 'top',
        });
        throw res;
      }
    });
}

// 新增投诉
export function addComplaintCollection(param) {
  const config = {
    dataType: 'json',
    contentType: 'application/json',
  };
  return http
    .post(
      '/workscene/workscene/v1/complaint/addComplaintCollection',
      param,
      {},
      config
    )
    .then(res => {
      if (res.status === 200) {
        return res.data;
      } else {
        Toast({
          message: res.message || '提交失败',
          duration: 3000,
          position: 'top',
        });
        throw res;
      }
    });
}

export function getTemplateDetail(id) {
  return http
    .get(`/workscene/workscene/v1/complaint/complaintTemplateDetail?id=${id}`)
    .then(res => {
      if (res.status === 200) {
        return res.data;
      } else {
        throw res;
      }
    });
}

export function getTemplateDetailForApp() {
  return http
    .get('/workscene/workscene/v1/complaint/complaintTemplateDetailForApp')
    .then(res => {
      if (res.status === 200) {
        return res.data;
      } else {
        throw res;
      }
    });
}
